import React from "react";
import { CheckCircle2, FileText, Settings, BarChart3 } from "lucide-react";
import { useTranslation } from "react-i18next";

export function CompletionStep() {
  const { t } = useTranslation();

  const nextSteps = [
    { text: t('setupGuide.completion.nextStep1', 'Add your first contract'), icon: FileText },
    { text: t('setupGuide.completion.nextStep2', 'Invite team members to collaborate'), icon: Settings },
    { text: t('setupGuide.completion.nextStep3', 'Set up notifications for contract renewals'), icon: Settings },
    { text: t('setupGuide.completion.nextStep4', 'Explore the reporting and analytics features'), icon: BarChart3 },
  ];

  return (
    <div className="space-y-4 text-center">
      <div className="flex justify-center mb-4">
        <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
          <CheckCircle2 className="h-7 w-7 text-primary" />
        </div>
      </div>
      
      <h2 className="text-xl font-semibold">{t('setupGuide.completion.title', 'Setup Complete!')}</h2>
      
      <p className="text-muted-foreground text-sm">
        {t('setupGuide.completion.description', "You're all set! Your account is configured and ready to use.")}
      </p>
      
      <div className="bg-muted p-4 rounded-lg text-left">
        <h3 className="font-medium mb-2 text-sm">{t('setupGuide.completion.whatsNext', "What's Next?")}</h3>
        <ul className="space-y-2">
          {nextSteps.map((step, index) => {
            const Icon = step.icon;
            return (
              <li key={index} className="flex items-center gap-2">
                <Icon className="h-4 w-4 text-primary shrink-0" />
                <span className="text-sm">{step.text}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
